import React, { useRef, useState } from 'react';
import './Timeline.css';

const Timeline = ({ currentIndex, totalMessages, onSeek, duration, messages, startTime }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [hoverPosition, setHoverPosition] = useState(null);
  const timelineRef = useRef(null);

  const progress = totalMessages > 0 ? (currentIndex / (totalMessages - 1)) * 100 : 0;

  const handleClick = (e) => {
    if (!timelineRef.current || totalMessages === 0) return;
    
    const rect = timelineRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percentage = x / rect.width;
    const newIndex = Math.floor(percentage * (totalMessages - 1));
    
    onSeek(Math.max(0, Math.min(newIndex, totalMessages - 1)));
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    handleClick(e);
  };

  const handleMouseMove = (e) => {
    if (!timelineRef.current) return;

    const rect = timelineRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percentage = Math.max(0, Math.min(x / rect.width, 1));
    
    setHoverPosition({
      percentage,
      x: x
    });

    if (isDragging) {
      const newIndex = Math.floor(percentage * (totalMessages - 1));
      onSeek(Math.max(0, Math.min(newIndex, totalMessages - 1)));
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseLeave = () => {
    setHoverPosition(null);
    if (isDragging) {
      setIsDragging(false);
    }
  };

  const getTimeAtPosition = (percentage) => {
    if (!messages.length || !startTime) return '0:00.000';
    
    const messageIndex = Math.floor(percentage * (totalMessages - 1));
    const message = messages[messageIndex];
    
    if (!message) return '0:00.000';
    
    const timeInSeconds = Number(message.logTime - startTime) / 1e9;
    const mins = Math.floor(timeInSeconds / 60);
    const secs = Math.floor(timeInSeconds % 60);
    const ms = Math.floor((timeInSeconds % 1) * 1000);
    
    return `${mins}:${secs.toString().padStart(2, '0')}.${ms.toString().padStart(3, '0')}`;
  };

  return (
    <div className="timeline-container">
      <div className="timeline-label">Timeline</div>
      <div
        ref={timelineRef}
        className={`timeline ${isDragging ? 'dragging' : ''}`}
        onClick={handleClick}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseLeave}
      >
        <div className="timeline-track">
          <div 
            className="timeline-progress" 
            style={{ width: `${progress}%` }}
          />
          <div 
            className="timeline-handle" 
            style={{ left: `${progress}%` }}
          >
            <div className="handle-indicator"></div>
          </div>
          
          {hoverPosition && (
            <div 
              className="timeline-tooltip" 
              style={{ left: `${hoverPosition.x}px` }}
            >
              {getTimeAtPosition(hoverPosition.percentage)}
            </div>
          )}
        </div>
        
        <div className="timeline-markers">
          <span className="marker start">Start</span>
          <span className="marker end">End</span>
        </div>
      </div>
    </div>
  );
};

export default Timeline;
